import Vue from 'vue'
import Vuex from 'vuex'

import map from './map'
import filters from './filters'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    map,
    filters
  }
})
